// config/gameAnalytics.js
// Import centralized constants for consistency
import { WISHLIST_THRESHOLDS, PUBLISHER_CLASSES } from '../constants/systemConstants.js';

export const gameAnalyticsConfig = {
  // Default filters using centralized constants
  filters: {
    includeEarlyAccess: true,
    includeUnreleased: true,
    minWishlist: WISHLIST_THRESHOLDS.EXCEPTIONAL, // Use centralized constant instead of hardcoded 50000
    minFollowers: WISHLIST_THRESHOLDS.EXCEPTIONAL, // Reuse wishlist constant for consistency
    minScore: 18,
    publisherClasses: PUBLISHER_CLASSES.ALL.filter(cls => cls !== 'Hobbyist') // Use centralized constant
  },

  // Scoring configuration
  scoring: {
    genres: {
      'Action': 5,
      'Combat': 3,
      'Military': 3,
      'PvP': 2
    },
    tags: {
      'Shooter': 5,
      'Third Person': 3,
      'FPS': 2,
      'Combat': 2,
      'Multiplayer': 1,
      'PvP': 1
    }
  },

  // Publisher classification using centralized constant
  publisherClasses: PUBLISHER_CLASSES.ALL,

  // Dropdown options using centralized constants where possible
  dropdownOptions: {
    wishlistThresholds: [
      { value: WISHLIST_THRESHOLDS.MINIMAL, label: '10+' },
      { value: WISHLIST_THRESHOLDS.LOW, label: '50+' },
      { value: WISHLIST_THRESHOLDS.MEDIUM, label: '500+' },
      { value: WISHLIST_THRESHOLDS.HIGH, label: '1,000+' },
      { value: WISHLIST_THRESHOLDS.VERY_HIGH, label: '5,000+' },
      { value: WISHLIST_THRESHOLDS.EXCEPTIONAL, label: '10,000+' }
    ],
    followerThresholds: [
      { value: 100, label: '100+' },
      { value: 500, label: '500+' },
      { value: 1000, label: '1,000+' },
      { value: 5000, label: '5,000+' },
      { value: 10000, label: '10,000+' },
      { value: 50000, label: '50,000+' },
      { value: 100000, label: '100,000+' }
    ]
  },

  // Processing configuration
  processing: {
    batchSize: 50 // Keep as simple number since frontend doesn't need PROCESSING_LIMITS
  }
};